// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1yt8z","topBottomGutter":"Layout_topBottomGutter__39xqm"};